// handle scroll on blog filter
(function () {
  const filterList = document.querySelector(".main-blog__filter__list");
  if (filterList) {
    setTimeout(() => {
      const activeItem = filterList.querySelector(".active");
      if (activeItem) {
        const targetScrollLeft = activeItem.offsetLeft - 50;
        const start = filterList.scrollLeft;
        const distance = targetScrollLeft - start;
        const duration = 500;
        let startTime = null;

        function animation(currentTime) {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          const ease = progress * (2 - progress); // easeOutQuad
          filterList.scrollLeft = start + distance * ease;
          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          }
        }

        requestAnimationFrame(animation);
      }
    }, 100);
  }
})();
